import React from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import { getId } from "./field";

const Label = ({
    input,
    option,
    children,
    required = false,
    ...props
}) => {
    const context = useFormContext();
    const id = getId(input, context, option);

    return (
        <div className="smart-label">
            <label htmlFor={id} {...props}>{ children }</label>
            {required && <span className="text-lx inline-required">
                <i className="far fa-asterisk" />
            </span>}
        </div>
    );
};

Label.propTypes = {
    input: propTypes.string.isRequired,
    option: propTypes.oneOfType([
        propTypes.string,
        propTypes.number,
    ]),
    children: propTypes.any,
    required: propTypes.bool
};

export default Label;